import { useEffect } from 'react';

/** Stops the page behind an open modal from scrolling, padding for the hidden scrollbar so nothing shifts. */
export default function useBodyScrollLock(isLocked: boolean) {
    useEffect(() => {
        if (typeof document === 'undefined' || !isLocked) return undefined;
        const { body } = document;
        const previousOverflow = body.style.overflow;
        const previousPaddingRight = body.style.paddingRight;

        const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
        if (scrollBarWidth > 0) {
            body.style.paddingRight = `${scrollBarWidth}px`;
        }
        body.style.overflow = 'hidden';

        return () => {
            body.style.overflow = previousOverflow;
            body.style.paddingRight = previousPaddingRight;
        };
    }, [isLocked]);
}
